// We don't want to show more than 3-digit numbers in topbar notifications
// and messages as it would take too much space
export const getBadgeNumberWithMax3Digits = (inputNumber?: number) =>
  Math.min(inputNumber ?? 0, 999);
